import MUIBox, { BoxProps as MUIBoxProps } from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import {
  SystemProps,
  unstable_extendSxProp as extendSxProp
} from '@mui/system';
import React from 'react';

/**
 * Keep MUI v7-style system props (`mt`, `display`, `height`, …) working on our
 * Box wrapper. Material UI v9 removed them from the public API in favor of `sx`;
 * `extendSxProp` still maps those props into `sx` for backwards compatibility.
 */
export type BoxProps = MUIBoxProps & SystemProps<Theme>;

/** Extension of [Material-UI Box](https://mui.com/material-ui/react-box/)
 *
 * The Box component serves as a wrapper component for most of the CSS utility needs.
 */
export const Box = ({ children, ...props }: BoxProps) => {
  return <MUIBox {...extendSxProp(props)}>{children}</MUIBox>;
};
